import { useStore } from "@nanostores/react";

import {
  currentTrackId,
  reproduceTrack,
  trackReproduced,
} from "@/stores/player/playerStore";

import Paragraph from "@/components/shared/text/paragraph";
import { PlayPauseButton } from "../track/track-reproduce/PlayPauseButton";

export const PlayerDetail = () => {
  const track = useStore(trackReproduced);
  const $currentTrackId = useStore(currentTrackId);
  if (!track) return null;

  return (
    <div className="flex flex-1 items-center gap-x-4">
      <img
        src={track.cover}
        className="hidden aspect-square h-10 w-10 rounded sm:block"
      />
      <div className="sm:hidden">
        <PlayPauseButton
          player
          track={track}
          isPlaying={$currentTrackId === track.id}
          onClick={() => reproduceTrack(track)}
          aria-label={$currentTrackId === track.id ? "Pause" : "Play"}
        />
      </div>
      <div>
        <Paragraph className="line-clamp-1 text-white">{track.name}</Paragraph>
        <Paragraph size="sm" className="text-white-70">
          {track.album}
        </Paragraph>
      </div>
    </div>
  );
};
